import { useState, useEffect } from 'react';

import { Formik, Form, Field as FormikField } from 'formik';

import PropTypes from 'prop-types';

import * as Yup from 'yup';

import { TextField } from 'formik-mui';

import FormHelperText from '@mui/material/FormHelperText';

import _ from 'lodash';

import { Button, Dropdown } from '../shared';

import { contactUsDomain } from '../../domain';

const leadGenInitialValues = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    salesPerson: '',
    building: '',
    roomType: '',
};
const leadGenValidationSchema = Yup.object({
    firstName: Yup.string('').required('Customer name is required'),
    lastName: Yup.string('').required('Customer surname is required'),
    email: Yup.string('').email('Enter a valid email').required('Email is required'),
    phoneNumber: Yup.string('')
        .matches(/^[0-9,+]*$/, 'Phone number is invalid')
        .min(10, 'Phone number is too short (minimum 10)')
        .max(15, 'Phone number is too long (maximum 15)')
        .required('Phone number is required'),
    salesPerson: Yup.string('').required('Sale person name is required'),
    building: Yup.string('').required('Building name is required'),
    roomType: Yup.string('').required('Room type category is required'),
});

const salesPersons = [];
const buildings = [];
const roomCategories = [];

const LeadGenSalesForm = (props) => {
    const { formBuildingData, formRoomTypeCategoriesData, formSalesAgentsData } = props;
    const [contactUsSubmitError, setContactUsSubmitError] = useState(null);
    const [successfullySubmitted, setSuccessfullySubmitted] = useState(false);
    const [selectedSalesPerson, setSelectedSalesPerson] = useState(null);
    const [selectedBuilding, setSelectedBuilding] = useState(null);
    const [selectedRoomTypeCategory, setSelectedRoomTypeCategory] = useState(null);  
   

    useEffect(() => {
        buildOptionFromButter(formSalesAgentsData, 'name_and_surname', salesPersons);
        buildOptionFromButter(formBuildingData, 'building_name', buildings);
        buildOptionFromButter(formRoomTypeCategoriesData, 'category', roomCategories);
    }, [salesPersons, buildings, roomCategories]);

    const buildOptionFromButter = (data, objectPropertyFromButter, array) => {
        _.forEach(data, (dataEntry) => {
            const obj = {
                label: dataEntry[objectPropertyFromButter],
                value: dataEntry[objectPropertyFromButter],
                id: `${dataEntry[objectPropertyFromButter]}-select`,
            };
            array.push(obj);
        });
    };

    const onSalesPersonsChanged = (salesPerson, event, formikOnChange) => {
        setSelectedSalesPerson(salesPerson);
        formikOnChange(event);
    };

    const onBuildingsChanged = (building, event, formikOnChange) => {
        setSelectedBuilding(building);
        formikOnChange(event);
    };

    const onRoomTypeCategoryChanged = (roomTypeCategory, event, formikOnChange) => {
        setSelectedRoomTypeCategory(roomTypeCategory);
        formikOnChange(event);
    };

    const onSubmit = async ({
        firstName,
        lastName,
        email,
        phoneNumber,
        salesPerson,
        building,
        roomType,
    }) => {
        try {
            await contactUsDomain.submitLeadFromSalesPerson(
                firstName,
                lastName,
                phoneNumber,
                email,
                salesPerson,
                building,
                roomType,
            );

            setContactUsSubmitError(null);
            setSuccessfullySubmitted(true);
        } catch (error) {
            setContactUsSubmitError(error.message);
            setSuccessfullySubmitted(false);
        }
    };

    const ThankYouMessage = () => {
        if (!successfullySubmitted) {
            return null;
        }

        return (
            <div className='sales-lead-gen-form-card-container'>
                <div className='sales-lead-gen-thank-you-message-container'>
                    <h3>Thanks for Getting in Touch!</h3>
                    <p>Customer information captured.</p>
                </div>
            </div>
        );
    };

    const renderDesktopForm = () => {
        if (successfullySubmitted) {
            return null;
        }
        return (
            <div className='sales-lead-gen-form-container'>
                <div>
                    <Formik
                        initialValues={leadGenInitialValues}
                        validationSchema={leadGenValidationSchema}
                        onSubmit={onSubmit}
                        validateOnBlur
                        validateOnChange={false}
                    >
                        {({
                            submitForm,
                            isSubmitting,
                            touched,
                            errors,
                            handleChange,
                            handleBlur,
                        }) => (
                            <Form className='sales-lead-gen-form'>
                                <FormikField className='sales-lead-gen-field'
                                    component={TextField}
                                    required
                                    name="firstName"
                                    id="firstName"
                                    type="text"
                                    label="Customer Name"
                                    variant="outlined"
                                    color="secondary"
                                    helperText={touched.firstName ? errors.firstName : ''}
                                    error={touched.firstName && !!errors.firstName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    fullWidth
                                />
                                <FormikField className='sales-lead-gen-field'
                                    component={TextField}
                                    required
                                    name="lastName"
                                    id="lastName"
                                    type="text"
                                    label="Customer Surname"
                                    variant="outlined"
                                    color="secondary"
                                    helperText={touched.lastName ? errors.lastName : ''}
                                    error={touched.lastName && !!errors.lastName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    fullWidth
                                />
                                <FormikField className='sales-lead-gen-field'
                                    component={TextField}
                                    required
                                    name="phoneNumber"
                                    id="phoneNumber"
                                    type="tel"
                                    label="Contact Number"
                                    variant="outlined"
                                    color="secondary"
                                    helperText={touched.phoneNumber ? errors.phoneNumber : ''}
                                    error={touched.phoneNumber && !!errors.phoneNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    fullWidth
                                />
                                <FormikField className='sales-lead-gen-field'
                                    component={TextField}
                                    required
                                    name="email"
                                    id="email"
                                    type="email"
                                    label="Email Address"
                                    variant="outlined"
                                    color="secondary"
                                    helperText={touched.email ? errors.email : ''}
                                    error={touched.email && !!errors.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    fullWidth
                                />
                                <div className='sales-lead-gen-dropdown-container'>
                                    <Dropdown
                                        placeholder="Promoter *"
                                        selectId="sales_person_dropdown"
                                        options={salesPersons}
                                        onChange={(_salesPerson, event) => {
                                            onSalesPersonsChanged(
                                                _salesPerson,
                                                event,
                                                handleChange,
                                            );
                                        }}
                                        name="salesPerson"
                                        defaultValue={selectedSalesPerson}
                                        helperText={touched.salesPerson ? errors.salesPerson : ''}
                                        error={touched.salesPerson && !!errors.salesPerson}
                                        handleBlur={handleBlur}
                                    />
                                </div>
                                <div className='sales-lead-gen-dropdown-container'>
                                    <Dropdown
                                        placeholder="Building *"
                                        selectId="building_dropdown"
                                        options={buildings}
                                        onChange={(_building, event) => {
                                            onBuildingsChanged(_building, event, handleChange);
                                        }}
                                        name="building"
                                        defaultValue={selectedBuilding}
                                        helperText={touched.building ? errors.building : ''}
                                        error={touched.building && !!errors.building}
                                        handleBlur={handleBlur}
                                    />
                                </div>
                                <div className='sales-lead-gen-dropdown-container'>
                                    <Dropdown
                                        placeholder="Room Type Category *"
                                        selectId="roomtype_category_dropdown"
                                        options={roomCategories}
                                        onChange={(_roomTypeCategpry, event) => {
                                            onRoomTypeCategoryChanged(
                                                _roomTypeCategpry,
                                                event,
                                                handleChange,
                                            );
                                        }}
                                        name="roomType"
                                        defaultValue={selectedRoomTypeCategory}
                                        helperText={touched.roomType ? errors.roomType : ''}
                                        error={touched.roomType && !!errors.roomType}
                                        handleBlur={handleBlur}
                                    />
                                </div>
                                <FormHelperText error>{contactUsSubmitError}</FormHelperText>
                                <div className='sales-lead-gen-button-container'>
                                    <Button
                                        id="sales-lead-gen-submit-button"
                                        className='sales-lead-gen-submit-button'                                   
                                        variant="contained"
                                        color="primary"
                                        isLoading={isSubmitting}
                                        onClick={submitForm}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        );
    };

    return (
        <div className='sales-lead-gen-absolute-container'>
            {!successfullySubmitted && (
                <div className='sales-lead-gen-form-card-container'>
                    <div className='sales-lead-gen-form-header'>
                        <h3>Time to Connect</h3>
                        <p className='sales-lead-gen-paragraph'>
                            Your best life is a few clicks away!
                        </p>
                    </div>
                    {renderDesktopForm()}
                </div>
            )}

            <ThankYouMessage />
        </div>
    );
};

export default LeadGenSalesForm;

LeadGenSalesForm.propTypes = {
    formBuildingData: PropTypes.array,
    formRoomTypeCategoriesData: PropTypes.array,
    formSalesAgentsData: PropTypes.array,
};
